import script from "./ImpactMeter.vue?vue&type=script&setup=true&lang=js"
export * from "./ImpactMeter.vue?vue&type=script&setup=true&lang=js"

import "./ImpactMeter.vue?vue&type=style&index=0&id=e3f1485e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3f1485e"]])

export default __exports__